import { all, fork } from "redux-saga/effects";
import billing from "./billing/billing";
import casesWatcher from "./cases/casesSaga";
import contractWatcher from "./contract/contractSaga";
import global from "./global/global";
import invoiceHistoryWatcher from "./billing/invoiceHistorySaga";
import paymentHistoryWatcher from "./billing/paymentHistorySaga";
import technicianAppointmentWatcher from "./schedulingportal/technicianAppointmentSaga";

export default function* root() {
  yield all([fork(global), fork(billing), fork(casesWatcher), fork(invoiceHistoryWatcher), fork(paymentHistoryWatcher), fork(contractWatcher), fork(technicianAppointmentWatcher)]);
}
